export default {
    webhooksList: {},
    webhooksFields: [
        {
            key: 'title',
            label: 'Title',
            sortable: true,
        },
        {
            key: 'endpointUrl',
            label: 'Endpoint URL',
            sortable: true,
        },
        {
            key: 'apiKey',
            label: 'API Key',
        },
        {
            key: 'apiKeyValue',
            label: 'API Key Value',
        },
        {
            key: 'triggerPoint',
            label: 'Trigger Point',
            sortable: true,
        },
        {
            key: 'description',
            label: 'Description',
            sortable: true,
        },
        {
            key: 'status',
            label: 'Status',
            sortable: true,
            class: 'text-center status-absolute-pos',
        },
        {
            key: 'action',
            label: 'Action',
            tdClass: 'user-roles-action',
        },
    ],
}
